var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitalsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vitals"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 9.00005C22 9.00004 22 9.00002 22 9C22 5.68629 19.3137 3 16 3C14.4633 3 13.0615 3.57771 12 4.52779C10.9385 3.57771 9.53671 3 8 3C4.68629 3 2 5.68629 2 9C2 9.00003 2 9.00006 2 9.00009C2 16.3512 8.67146 19.8061 11.116 20.8254C11.6855 21.0628 12.3145 21.0628 12.884 20.8254C15.3285 19.8061 22 16.3512 22 9.00005Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M21.8271 11H17.1594L15.9191 8.10608C15.7615 7.7384 15.4 7.5 15 7.5C14.5999 7.5 14.2384 7.7384 14.0808 8.10608L12 12.9614L11.4191 11.6061C11.2615 11.2384 10.9 11 10.5 11H2.17285C2.29865 11.7092 2.48905 12.3752 2.73068 13H9.84056L11.0808 15.8939C11.2384 16.2616 11.5999 16.5 12 16.5C12.4 16.5 12.7615 16.2616 12.9191 15.8939L15 11.0386L15.5808 12.3939C15.7384 12.7616 16.0999 13 16.5 13H21.2692C21.5109 12.3752 21.7013 11.7092 21.8271 11Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalsDark);
export default __webpack_public_path__ + "static/media/vitals-dark.ea9e7092ddac568939a1394152bd4e7d.svg";
export { ForwardRef as ReactComponent };